import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommunicatorService } from '@app/shared/services/communicator.service';
import { CustomMissingTranslationHandler } from '@app/utils/custom-missing-translation-handler';
import { LangSwitchedTranslateHttpLoader } from '@app/utils/language-switched-translate-http-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IframeCoordinatorClientService } from './shared/services/iframe-coordinator-client.service';

/** Main app module definition and bootstrapping */
@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule, // re-exports CommonModule
        NgSelectModule,
        FormsModule,
        AppRoutingModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translateHttpLoaderFactory,
                deps: [HttpClient]
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: CustomMissingTranslationHandler
            }
        }),
        BrowserAnimationsModule], providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
        CommunicatorService,
        provideAppInitializer(() => {
        const initializerFn = (ifcLoader)(inject(IframeCoordinatorClientService));

        return initializerFn();
      }),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}

// AoT requires an exported function for factories
export function translateHttpLoaderFactory(http: HttpClient): LangSwitchedTranslateHttpLoader {
  return new LangSwitchedTranslateHttpLoader(http);
}

export function ifcLoader(ifc: IframeCoordinatorClientService) {
  return () => ifc.init();
}
